export const GA_TRACKING_ID = 'G-989559X7JL'

export const pageview = (url: string) => {
  // @ts-ignore
  if (!window.gtag) return
  // @ts-ignore
  window.gtag('config', GA_TRACKING_ID, {
    page_path: url,
  })
}

type GaEvent = {
  action: any
  category: string
  label: string
  value?: string
}

export const event = ({ action, category, label, value }: GaEvent) => {
  // @ts-ignore
  if (!window.gtag) return
  // @ts-ignore
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    value,
  })
}
